export const quote = {
  quote: {
    confirmDialog: {
      name: "Name:",
      description: "Description:",
      validity: "This quote is valid until {{ expirationTime }}",
      option: {
        yes: "Yes",
        no: "No"
      },
      buyer: {
        submit: {
          a11y: {
            close: "Close submit quote modal"
          },
          title: "Submit Quote Request {{ code }}?",
          confirmNote: "Are you sure you want to submit this quote request?",
          successMessage: "Quote request submitted successfully"
        },
        cancel: {
          a11y: {
            close: "Close cancel quote modal"
          },
          title: "Cancel Quote Request {{ code }}?",
          confirmNote: "Are you sure you want to cancel this quote request?",
          successMessage: "Quote request cancelled"
        }
      },
      buyer_offer: {
        edit: {
          a11y: {
            close: "Close edit quote modal"
          },
          title: "Confirm Edit Quote {{ code }}?",
          confirmNote: "Are you sure you want to edit this approved quote?",
          warningNote: "This Quote has been Approved. Editing this Quote will prevent Checkout until new edits are approved."
        },
        cancel: {
          a11y: {
            close: "Close cancel quote modal"
          },
          title: "Cancel Quote {{ code }}?",
          confirmNote: "Are you sure you want to cancel this quote?",
          successMessage: "Quote cancelled"
        },
        checkout: {
          a11y: {
            close: "Close checkout quote modal"
          },
          title: "Checkout Quote {{ code }}?",
          confirmNote: "Are you sure you want to accept and checkout this quote?"
        }
      },
      expired: {
        edit: {
          a11y: {
            close: "Close edit quote modal"
          },
          title: "Confirm Edit Quote {{ code }}?",
          confirmNote: "Are you sure you want to edit this expired quote?",
          warningNote: "This Quote is expired. Editing this quote will prevent checkout until new edits are approved."
        },
        requote: {
          a11y: {
            close: "Close requote modal"
          },
          title: "Recreate Quote Request {{ code }}?",
          confirmNote: "Are you sure you want to recreate this quote request?",
          warningNote: "This Quote is expired. Re-quoting it will create a new quote request with same contents, which can be edited and submitted for approval afterwards."
        }
      },
      seller: {
        submit: {
          a11y: {
            close: "Close submit quote modal"
          },
          title: "Submit Quote {{ code }}?",
          confirmNote: "Are you sure you want to submit this quote?",
          warningNote: "Depending on the total value of the quote, an additional approval might be required before the buyer can check out this quote.",
          successMessage: "Quote submitted successfully"
        }
      },
      sellerapprover: {
        approve: {
          a11y: {
            close: "Close approve quote modal"
          },
          title: "Approve Quote {{ code }}?",
          confirmNote: "Are you sure you want to approve this quote?",
          successMessage: "Quote approved successfully"
        },
        reject: {
          a11y: {
            close: "Close reject quote modal"
          },
          title: "Reject Quote {{ code }}?",
          confirmNote: "Are you sure you want to reject this quote?",
          successMessage: "Quote rejected"
        }
      },
      cancelled: {
        requote: {
          a11y: {
            close: "Close requote modal"
          },
          title: "Recreate Quote Request {{ code }}?",
          confirmNote: "Are you sure you want to recreate this quote request?",
          warningNote: "Your current cart will be converted to a saved cart."
        }
      },
      all: {
        edit: {
          a11y: {
            close: "Close edit quote modal"
          },
          title: "Edit Quote {{ code }}?",
          confirmNote: "Are you sure you want to edit this quote?",
          warningNote: "Your current cart will be converted to a saved cart."
        }
      }
    },
    comments: {
      regionTitle: "Contact/comments box",
      title: "Contact",
      invalidComment: "Invalid entry - Please try again...",
      allProducts: "All products"
    },
    commons: {
      requestQuote: "Request quote",
      cart: "Cart",
      minRequestInitiationNote: "A minimum subtotal of ${{minValue}} is required to submit a quote",
      minRequestWeightNote: "To request a quote, the total weight must be at least {{ weight }} Kg",
      savedActiveCart: "Your active cart was converted into the saved cart {{ code }}",
      contractProductsInCartNote : "It is not possible to request quotes for promotional products:"
    },
    header: {
      buyerEdit: {
        a11y: {
          cancel: "Cancel editing quote header information",
          save: "Save quote header information"
        }
      },
      overview: {
        regionTitle: "Quote details summary",
        id: "Quote ID",
        status: "Status",
        information: "Quote information",
        name: "Name",
        description: "Description",
        charactersLeft: "characters left: {{count}}",
        priceAndExpiry: "Price and expiration",
        estimatedTotal: "Estimated total",
        total: "Total",
        expirationTime: "Expiration date",
        a11y: {
          edit: "Edit quote header information"
        },
        createdAndUpdated: "Created and updated",
        createdDate: "Created",
        lastUpdatedDate: "Last updated"
      }
    },
    httpHandlers: {
      cartValidationIssue: "There are issues with your entries. Please check your cart.",
      quoteCartIssue: "Changes to cart entries are not allowed. Proceed to checkout",
      absoluteDiscountIssue: "Choose a discount that does not exceed the total value",
      expirationDateIssue: "Choose an expiration date in the future",
      threshold: {
        underThresholdError: "The requested quote total price does not meet the minimum threshold"
      },
      expired: "This quote has expired. You must resubmit your quote request to receive another offer from the supplier.",
      downloadPDFError: "Something went wrong. Could not retrieve the proposal PDF document."
    },
    items: {
      regionTitle: "Cart items"
    },
    links: {
      newCart: "New cart",
      quotes: "Quotes",
      download: "Download proposal",
      a11y: {
        newCart: "Create a new empty cart and navigate to it.",
        quotes: "Navigate to the quote search results list.",
        download: "Initiate the download of a quote proposal"
      }
    },
    list: {
      regionTitle: "Quote list summary",
      title: "Quote list",
      name: "Name",
      updated: "Updated",
      sortBy: "Sort by",
      sortQuotes: "Sort quotes",
      empty: "We have no quote records for this account.",
      quoteId: "Quote ID",
      status: "Status",
      clickableRow: "Click the row for more quote details"
    },
    states: {
      BUYER_DRAFT: "Draft",
      BUYER_SUBMITTED: "Submitted",
      BUYER_ACCEPTED: "Accepted",
      BUYER_APPROVED: "Approved",
      BUYER_REJECTED: "Rejected",
      BUYER_OFFER: "Supplier quote",
      BUYER_ORDERED: "Ordered",
      SELLER_DRAFT: "Draft",
      SELLER_REQUEST: "Requested",
      SELLER_SUBMITTED: "Submitted",
      SELLERAPPROVER_DRAFT: "Draft",
      SELLERAPPROVER_PENDING: "Pending approval",
      SELLERAPPROVER_APPROVED: "Approved",
      SELLERAPPROVER_REJECTED: "Rejected",
      CREATED: "Created",
      CANCELLED: "Cancelled",
      EXPIRED: "Expired"
    },
    summary: {
      regionTitle: "Order summary",
      actions: {
        APPROVE: "Approve quote",
        CANCEL: "Cancel quote",
        CHECKOUT: "Accept and pay",
        EDIT: "Edit quote",
        REJECT: "Reject quote",
        REQUOTE: "Request new quote",
        SAVE: "Save quote",
        SUBMIT: "Submit quote",
        VIEW: "View quote"
      },
      prices: {
        title: "Order summary",
        subtotal: "Subtotal",
        productDiscount: "Item discount",
        orderDiscount: "Order discount",
        quoteDiscount: "Quote discount",
        total: "Total",
        hint: "Taxes are not included in the total"
      },
      sellerEdit: {
        discount: "Discount",
        apply: "Apply",
        expiryDate: "Expiration date",
        discountValidationText: "Enter a valid discount percentage",
        a11y: {
          apply: "Click to apply the entered discount value to this quote",
          discount: "Enter a discount percentage to apply to this quote",
          expiryDate: "Enter an expiration date for this quote"
        }
      }
    }
  }
}
